export default __webpack_public_path__ + "static/media/Group380@2x.dd20fcf2.png";